import { render, staticRenderFns } from "./PropertiesGridList.html?vue&type=template&id=22a6ac5e&scoped=true&"
import script from "./PropertiesGridList.ts?vue&type=script&lang=ts&"
export * from "./PropertiesGridList.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/properties/_properties.scss?vue&type=style&index=0&id=22a6ac5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a6ac5e",
  null
  
)

export default component.exports